export const PREPAGE = 10;
export const PERPAGEFORNODISTANCE = 12;
export const PERPAGEFORLARGE = 9;

export const EMAIL_PATTERN =
  /* eslint-disable-next-line */
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const LOCATIONCATEGORIES = [
  'Castrol Service',
  'Castrol Service Certified',
];

export const CountriesWithCustomizedWTB = ['ROU', 'ESP'];
export const CountriesWithCustomizedWTBImage = ['GBR'];

export const GLOBALFONTFAMILY = [
  {
    countries: ['CES', 'HRV', 'HUN', 'POL', 'RON', 'SLK', 'SLV', 'SRP', 'ROU'],
    fontFamily: 'Castrol Sans Central European,Arial,Helvetica,sans-serif',
  },
  {
    countries: ['BUL', 'KAZ', 'RUS', 'UKR'],
    fontFamily: 'Castrol Sans Cyrillic,Arial,Helvetica,sans-serif',
  },
  {
    countries: ['AZE'],
    fontFamily: 'HelveticaNeue-Bold',
  },
  {
    countries: ['VIE'],
    fontFamily: 'Castrol Sans VI Regular',
  },
  {
    countries: [
      'DAN',
      'DEU',
      'ENG',
      'SPA',
      'FIN',
      'FRA',
      'ITA',
      'NLD',
      'NOR',
      'POR',
      'SWE',
    ],
    fontFamily: 'Castrol Sans Western European,Arial,Helvetica,sans-serif',
  },
  {
    countries: ['JPN'],
    fontFamily: 'Meiryo,MS PGothic,Arial,Helvetica,sans-serif',
  },
];

export const NODISTANCECOUNTRIES = ['GBR'];

export const MAP_PROD_TO_LOCA = {
  Cars: 'Car Workshop',
  Motorcycles: 'Bike Workshop',
  'Commercial Vehicles': 'Commercial Vehicles Workshop',
};

export const RETAIL_OUTLET = 'Retail Outlet';

export const ONLYWTBCOUNTRIES = [
  'EST',
  'LVA',
  'LTU',
  'ALB',
  'BIH',
  'MLT',
  'BGR',
  'HRV',
  'ISL',
  'SRB',
  'SVN',
  'VEN',
  'BHR',
  'PAN',
  'LBH',
  'ETH',
  'LBY',
  'SLV',
  'SLE',
  'BGD',
  'MUS',
  'YEM',
  'IRQ',
  'GHA',
  'KOR',
  'URY',
  'LBN',
  'AGO',
  'ARG',
  'BOL',
  'BRA',
  'CHN',
  'CRI',
  'CUW',
  'EGY',
  'GMB',
  'GTM',
  'HND',
  'ISR',
  'JPN',
  'KWT',
  'MDV',
  'MMR',
  'MOZ',
  'NGA',
  'OMN',
  'PAK',
  'PRY',
  'PER',
  'PHL',
  'PRI',
  'QAT',
  'LKA',
  'TWN',
  'TTO',
  'CHL',
  'PNG',
  'DJI',
  'COL',
];

export const FASTSCAN = 'FastScan';
export const APPNAME = 'ApplicationName';

export const PRESERVED = 'Preserved';
export const SEARCHSTATE = 'SearchState';

export const UNDETECT_LOCATION_PERMISSIONS = 'undetect_location_permissions';

export const ENABLEDWORKSHOPSOWNER = [
  'NLD',
  'DEU',
  'FRA',
  'RUS',
  'AUT',
  'FIN',
  'DAN',
  'SWE',
  'NOR',
  'CHE',
  'ITA',
  'GBR',
  'POL',
  'HUN',
  'CHE',
  'AUS',
  'NZL',
  'DNK',
  'CZE',
  'SVK',
];

export const QUICKSEARCH_DISABLE_COUNTRIES = ['MEX'];
export const ENABLED_LICENSE_PLATE_COUNTRIES = ['USA', 'AUS', 'NZL'];
export const ENABLED_LICENSE_PLATE_COUNTRIES_WITH_TRUCK = ['GBR', 'FRA'];
export const EUROPEAN_WITHOUT_SERVICE_TYPE_FILTER = [
  'AUT',
  'LTU',
  'NLD',
  'BEL',
  'NOR',
  'POL',
  'BGR',
  'PRT',
  'HRV',
  'ROU',
  'CZE',
  'SRB',
  'DNK',
  'SVK',
  'EST',
  'SVN',
  'FIN',
  'ESP',
  'FRA',
  'SWE',
  'GRC',
  'HUN',
  'ITA',
  'GBR',
  'UKR',
  'LVA',
  'ALB',
  'CYP',
  'BIH',
  'DEU',
];
export const EUROPEAN_COUNTRIES = [
  'AUT',
  'LTU',
  'NLD',
  'BEL',
  'NOR',
  'POL',
  'BGR',
  'PRT',
  'HRV',
  'ROU',
  'CZE',
  'SRB',
  'DNK',
  'SVK',
  'EST',
  'SVN',
  'FIN',
  'ESP',
  'FRA',
  'SWE',
  'GRC',
  'HUN',
  'ITA',
  'GBR',
  'UKR',
  'LVA',
  'ALB',
  'CYP',
  'BIH',
  'DEU',
];

export const LICENSE_PLATE_GEOCODED_STATE = ['USA'];

export const INIT_FILTER_DROPDOWN = {
  makeTypes: [],
  categoriesTypes: [],
  modelTypes: [],
  yearTypes: [],
};

export const NEW_UI_LICENSE_PLATE_REDIRECTS = [
  {
    name: 'Check Your Oil',
    url: 'https://www.checkyouroil.co.nz/',
    default: 'Vehicle & Equipment'
  }
];

export enum ANALYTICS_EVENT {
  OIL_SEARCH = 'oilSearches',
  VEHICLE_SEARCH = 'vehicleSearches',
  QUICK_SEARCH = 'quickSearches',
  OIL_SEARCH_UNAVAILABLE = 'detailsUnavailable_oilSearches',
  VEHICLE_SEARCH_UNAVAILABLE = 'detailsUnavailable_vehicleSearches',
  QUICK_SEARCH_UNAVAILABLE = 'detailsUnavailable_quickSearches',
  PRODUCT_FINDER_VIEW  = 'productFinderView',
  SELECT_WORKSHOP_OWNER = 'workshopOwnerClicks',
  SELECT_VEHICLE_OWNER = 'vehicleOwnerClicks',
  RECOMMENDATION_OIL_CLICK = 'viewRecommendedOilsClick',
  LICENSE_PLATE_SEARCH = 'licensePlateSearch',
  RECOMMENDED_OIL_VIEW = 'recommendedOilView',
  WHERE_TO_BUY_CLICK = 'whereToBuyClick',
  WHERE_TO_SERVICE_CLICK = 'whereToServiceClick',
  VIEW_RECOMMENDED_OILS_CLICK = 'viewRecommendedOilsClick',
  VIEW_PRODUCT_PAGE_CLICK = 'viewProductPageClick',
  WORKSHOP_OWNER_CLICKS = 'workshopOwnerClicks',
  VEHICLE_OWNER_CLICKS = 'vehicleOwnerClicks',
  READ_RECOMMENDED_PRODUCT_CLICKS = 'readRecommendedProductClick',
  BUY_ONLINE_CLICKS = 'buyOnlineClicks',
  PRODUCT_VIEW = 'productView',
  DATASHEET_CLICK = 'dataSheetClick',
  MATERIAL_SAFETY_DATASHEET_CLICK = 'materialSafetyDataSheetClick',
  WHERE_TO_BUY_CARD_CLICK = 'whereToBuyCardClick',
  WHERE_TO_BUY_URL_CLICK = 'whereToBuyUrlClick',
}

export enum ANALYTICS_SEARCH_TYPE {
  VEHICLE_SEARCH = 'vehicle search',
  OIL_SEARCH = 'oil search',
  QUICK_SEARCH = 'quick search',
  LICENSE_PLATE_SEARCH='licensePlateSearch'
}

export enum ANALYTICS_PAGE_TYPE {
  PRODUCT_FINDER = 'product finder',
  RECOMMENDED_OILS = 'recommended oils',
  PRODUCT_PAGE = 'product page',
  WHERE_TO_BUY = 'where to buy',
}

export enum ANALYTICS_BUTTON_NAME {
  VIEW_RECOMMENDATIONS = 'view recommended oils',
  WHERE_TO_BUY = 'where to buy',
  WHERE_TO_SERVICE = 'where to service',
  VIEW_RECOMMENDED_OILS = 'view recommended oils',
  VIEW_PRODUCT_PAGE = 'view product page',
  READ = 'read',
  BUY_ONLINE_BUTTON_PREFIX = 'buyOnline:',
  DATASHEETS = 'dataSheets',
  MATERIAL_SAFETY_DATASHEETS = 'materialSafetyDataSheets',
}

export enum ANALYTICS_USER_TYPE {
  WORKSHOP_OWNER = 'workshop owner',
  VEHICLE_OWNER = 'vehicle owner'
}
  
export enum ANALYTICS_RECOMMENDATION_TYPE {
  ALTERNATIVE_RECOMMENDATION = 'alternative recommendation',
}

export enum ANALYTICS_SERVICE_TYPE {
  BOOK_MY_GARAGE = 'Book My Garage',
}

export const NORDICS = ['SWE', 'DNK', 'NOR', 'FIN', 'ISL', 'EST', 'LVA', 'LTU'];

export const NEW_UI_COUNTRIES = ['AUS','NZL','MYS','TZA','BWA','NAM','IND','ZMB','SGP','MEX','ZAF','KEN','IDN','SAU','ARE','BEL','CZE','GRC','HUN','ITA','NLD','POL','PRT','ROU','DNK','FIN','FRA','DEU','NOR','GBR','SVK','ESP','SWE','CHE','AUT','DZA','THA','USA','VNM'];
export const NEW_UI_DISABLED_OILSEARCH = ['AUS', 'NZL'];

export const SUPPORTED_IMAGE_FORMAT = ['jpeg', 'jpg', 'png', 'tif'];

export const BACK_BUTTON_ENABLED_COUNTRIES = ['IND','MYS','VNM'];

export const DURATION = 1500;

export const CAROUSEL_PRODUCT_ENABLED = false;
export const CAROUSEL_PRODUCT_ID = 66666;
export const HEADER_CAROUSEL_PRODUCT_ENABLED = false;
export const HEADER_CAROUSEL_PRODUCT_ID = 66666;
export const DISABLED_OPENING_HOUR_COUNTRIES = ['GBR'];
export const ENABLED_LOCATION_PHOTO_COUNTRIES: string[] = [];
export const GOOGLE_AUTOCOMPLETE_TYPES = ["postal_code", "postal_town", "locality", "sublocality", "street_address"];
export const GOOGLE_AUTOCOMPLETE_FIELDS = ["formatted_address", "geometry"];
export const YEAR_API_CALL_ENABLED_COUNTRIES = ['IND', 'MEX'];
export const YEAR_MANDATORY_COUNTRIES = ['MEX'];
